import { Button, Tooltip } from "antd";

import { PlusOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import React from "react";

/* Action en pictogramme seul (theme commun) : bouton rond + infobulle, libelle lu
 * par les lecteurs d'ecran (aria-label). Le reste des props va au Button antd.
 * Le span fixe le DOM : sans lui, antd n'enveloppe le bouton que lorsqu'il est
 * desactive, et le noeud change a chaque bascule (infobulle comprise). */
function IconButton({ title, label, icon, className, ...rest }) {
  return (
    <Tooltip title={title}>
      <span className={`cti-icon-wrap${className ? ` ${className}` : ""}`}>
        <Button shape="circle" aria-label={label || title} icon={icon} {...rest} />
      </span>
    </Tooltip>
  );
}

IconButton.propTypes = {
  title: PropTypes.node.isRequired,
  label: PropTypes.string,
  icon: PropTypes.node.isRequired,
  className: PropTypes.string,
};

/* « Ajouter » : un « + » rond, couleur primaire. */
export function AddButton({ onClick, title = "Ajouter", ...rest }) {
  return (
    <IconButton
      className="cti-add"
      type="primary"
      title={title}
      icon={<PlusOutlined />}
      onClick={onClick}
      {...rest}
    />
  );
}

AddButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default IconButton;
